import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {DateTime} from "luxon";

export const useCommonStore = defineStore(
    'commonStore',
    () => {

        const rayonList = ref([
            {rayon: '1A'},
            {rayon: '1B'},
            {rayon: '1C'},
            {rayon: '1D'},
            {rayon: '1E'},
            {rayon: '1F'},
            {rayon: '1G'},
            {rayon: '1H'},
            {rayon: '2A'},
            {rayon: '2B'},
            {rayon: '2C'},
            {rayon: '3A'},
            {rayon: '3B'},
            {rayon: '3C'},
            {rayon: '4A'},
            {rayon: '4B'},
            {rayon: '4C'},
            {rayon: '4D'},
            {rayon: '5A'},
            {rayon: '5B'},
            {rayon: '5C'},
            {rayon: '6A'},
            {rayon: '6B'},
            {rayon: '6C'},
            {rayon: '6D'},
            {rayon: '6E'},
            {rayon: '7A'},
            {rayon: '7B'},
            {rayon: '7C'},
            {rayon: '8A'},
            {rayon: '9A'}
        ]);
        const golonganList = ref([
            {gol: 'S1'},
            {gol: 'S2'},
            {gol: 'R1'},
            {gol: 'P1'},
            {gol: 'N1'},
            {gol: 'N2'},
            {gol: 'I1'},
            {gol: 'I2'},
            {gol: 'K'},
            {gol: 'R2'},
            {gol: 'K1'}
        ]);
        const kelompokList = ref([
            {kelompok: 'SGR'},
            {kelompok: 'KBT'},
            {kelompok: 'SRT'},
            {kelompok: 'BSB'},
            {kelompok: 'GRK'},
            {kelompok: 'PCS'},
            {kelompok: 'SBR'},
            {kelompok: 'LOV'},
            {kelompok: 'ABRI'},
            {kelompok: 'POLRI'},
        ]);
        const kantorList = ref([
            {kantor: 'SGR'},
            {kantor: 'KBT'},
            {kantor: 'SRT'},
            {kantor: 'BSB'},
            {kantor: 'GRK'},
            {kantor: 'PCS'},
            {kantor: 'SBR'},
            {kantor: 'LOV'},
        ]);
        const rayonHeaderFilters = computed(() => {
            return rayonList.value.map((item) => {
                return {
                    text: item.rayon,
                    value: ['rayon', 'contains', item.rayon],
                };
            });
        });
        const golonganHeaderFilters = computed(() => {
            return golonganList.value.map((item) => {
                return {
                    text: item.gol,
                    value: ['gol', 'contains', item.gol],
                };
            });
        });
        const kelompokHeaderFilters = computed(() => {
            return kelompokList.value.map((item) => {
                return {
                    text: item.kelompok,
                    value: ['kelompok', 'contains', item.kelompok],
                };
            });
        });
        const kantorHeaderFilters = computed(() => {
            return kantorList.value.map((item) => {
                return {
                    text: item.kantor,
                    value: ['kantor', 'contains', item.kantor],
                };
            });
        });

        const last24Months = computed(() => {
            let months = [];
            let currentDate = DateTime.local();
            for (let i = 0; i < 36; i++) {
                const month = currentDate.month;
                const year = currentDate.year;
                const monthText = currentDate.monthLong;
                const formattedMonth = `${year}${month.toString().padStart(2, '0')}`;

                months.push({
                    value: formattedMonth,
                    text: `${monthText} ${year}`,
                });

                currentDate = currentDate.minus({ months: 1 }); // Update currentDate to the previous month
            }
            return months;
        });


        return {
            rayonHeaderFilters,
            golonganHeaderFilters,
            kelompokHeaderFilters,
            kantorHeaderFilters,
            last24Months,
        }
    });